<template>
  <div class="template-selector">
    <!-- 自定义tab导航 -->
    <div class="template-tabs">
      <!-- 刷新图标 -->
      <!-- <div class="refresh-icon" @click="clearCache" title="清空缓存">
        <i class="el-icon-refresh"></i>
      </div> -->
      <!-- 全部tab -->
      <div
        class="tab-item"
        :class="{
          active: activeName === 'all',
          first: true,
        }"
        @click="handleTabClick('all')"
      >
        全部
      </div>
      <div
        v-for="(item, index) in navList"
        :key="item.id"
        class="tab-item"
        :class="{
          active: activeName === `index${index}`,
          last: index === navList.length - 1,
        }"
        v-show="item.frontHide == 0"
        @click="handleTabClick(index)"
      >
        {{ item.groupName }}
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="template-content" v-loading="fromLoading">
      <!-- 模板列表 -->
      <div class="template-container">
        <div
          class="template-item"
          v-for="item in giftList"
          :key="item.id"
          @click="selectTemplate(item)"
        >
          <img :src="item.imageUrl" class="template-image" />
          <div class="template-name">
            {{ item.imageName }}
          </div>
          <img
            v-if="selectedTemplateId == item.id"
            class="template-selected-icon"
            src="https://yunqi-hd-public.tos-cn-beijing.volces.com/image/activityBtn/temp_selected.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getSystemTemplateGroup,
  sellerImage,
} from "@/api/paradiseAndTaskCommonController.js";
export default {
  props: {
    selectedTemplateId: {
      type: [String, Number],
      default: null,
    },
    // 模板组接口参数
    templateGroupParams: {
      type: Object,
      default: () => ({ smartCardType: 3 }), // 默认为会员卡片的
    },
    // 模板列表接口参数
    templateListParams: {
      type: Object,
      default: () => ({
        size: 10000,
        current: 1,
        source: 5,
      }),
    },
  },
  data() {
    return {
      fromLoading: false,
      activeName: "all", // 默认激活全部tab
      navList: [],
      giftList: [],
      recordData: {
        size: this.templateListParams.size || 10000,
        current: this.templateListParams.current || 1,
        total: 0,
      },
      navItem: null,
      // 缓存对象，key为templateGroupId，value为模板数据
      templateCache: {},
      // 所有模板数据
      allTemplatesData: {},
      // 全部模板的合并列表
      allTemplatesList: [],
    };
  },
  async created() {
    this.fromLoading = true;
    const GiftBag = await getSystemTemplateGroup(this.templateGroupParams);
    this.navList = GiftBag.data;

    if (this.navList.length > 0) {
      // 加载所有模板数据
      await this.loadAllTemplatesAtOnce();
      // 默认显示全部tab的内容
      this.showAllTemplates();
      // 如果没有selectedTemplateId，自动选择第一个模板
      if (!this.selectedTemplateId && this.allTemplatesList.length > 0) {
        this.selectTemplate(this.allTemplatesList[0]);
      }
    }

    this.fromLoading = false;
  },
  methods: {
    // 加载所有模板数据
    async loadAllTemplatesAtOnce() {
      try {
        // 获取所有可见tab的templateGroupId
        const templateGroupIds = this.navList
          .filter((item) => item.frontHide == 0)
          .map((item) => item.id);

        // 调用所有接口
        const promises = templateGroupIds.map((templateGroupId) => {
          const obj = {
            ...this.templateListParams,
            templateGroupId: templateGroupId,
          };
          return sellerImage(obj).then((response) => ({
            templateGroupId,
            data: response.data,
          }));
        });

        // 等待所有接口完成
        const results = await Promise.all(promises);

        // 将结果存储到缓存中
        results.forEach((result) => {
          this.templateCache[result.templateGroupId] = result.data.records;
          this.allTemplatesData[result.templateGroupId] = result.data;
        });

        // 生成全部模板列表
        this.generateAllTemplatesList();
      } catch (error) {
        console.error("批量加载模板数据失败:", error);
        // 如果批量加载失败，回退到原来的逐个加载方式
        await this.fallbackToSequentialLoad();
      }
    },

    // 逐个加载（兜底）
    async fallbackToSequentialLoad() {
      for (let i = 0; i < this.navList.length; i++) {
        const navItem = this.navList[i];
        if (navItem.frontHide == 0) {
          const templateGroupId = navItem.id;
          try {
            const obj = {
              ...this.templateListParams,
              templateGroupId: templateGroupId,
            };
            const { data } = await sellerImage(obj);
            this.templateCache[templateGroupId] = data.records;
            this.allTemplatesData[templateGroupId] = data;
          } catch (error) {
            console.error(`加载tab ${i} 数据失败:`, error);
          }
        }
      }
      // 生成全部模板列表
      this.generateAllTemplatesList();
    },

    // 生成全部模板列表
    generateAllTemplatesList() {
      this.allTemplatesList = [];
      let totalCount = 0;

      // 合并所有分类的模板
      Object.values(this.templateCache).forEach((templates) => {
        this.allTemplatesList.push(...templates);
        totalCount += templates.length;
      });

      // 更新总数
      this.recordData.total = totalCount;
    },

    // 显示全部模板
    showAllTemplates() {
      this.giftList = this.allTemplatesList;
      this.navItem = null; // 全部tab没有对应的navItem
    },

    // 更新当前tab的数据显示
    updateCurrentTabData() {
      if (this.navItem) {
        const templateGroupId = this.navItem.id;
        this.giftList = this.templateCache[templateGroupId] || [];

        // 更新recordData
        if (this.allTemplatesData[templateGroupId]) {
          this.recordData.total =
            this.allTemplatesData[templateGroupId].total * 1;
        }
      }
    },

    // tab点击方法
    handleTabClick(indexOrType) {
      if (indexOrType === "all") {
        // 点击全部tab
        this.activeName = "all";
        this.navItem = null;
        this.showAllTemplates();
      } else {
        // 点击具体分类tab
        this.activeName = `index${indexOrType}`;
        this.navItem = this.navList[indexOrType];
        this.updateCurrentTabData();
      }
    },

    // 清空缓存方法
    clearCache() {
      this.templateCache = {};
      this.allTemplatesData = {};
      this.allTemplatesList = [];
      // 重新批量加载所有数据
      this.fromLoading = true;
      this.loadAllTemplatesAtOnce().then(() => {
        // 清空缓存后显示全部tab
        this.activeName = "all";
        this.showAllTemplates();
        // 如果没有selectedTemplateId，自动选择第一个模板
        if (!this.selectedTemplateId && this.allTemplatesList.length > 0) {
          this.selectTemplate(this.allTemplatesList[0]);
        }
        this.fromLoading = false;
      });
    },

    // 选择模板方法
    selectTemplate(item) {
      this.$emit("handleChoice", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.template-selector {
  // background-color: #fff;
  border-radius: 6px;
  padding: 10px 0;
  min-height: 170px;
}

/* Tab样式 */
.template-tabs {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

/* 刷新图标样式 */
.refresh-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 24px;
  margin-right: 8px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fff;
  transition: all 0.3s;

  &:hover {
    color: #3159ff;
    border-color: #3159ff;
    background-color: #f0f7ff;
  }

  i {
    font-size: 14px;
  }
}

.tab-item {
  padding: 4px 8px;
  border: 1px solid #dcdfe6;
  line-height: 16px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.3s;
  margin-left: -1px;
  position: relative;
  font-size: 14px;
}

.tab-item.first {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  margin-left: 0;
}

.tab-item.last {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.tab-item:hover {
  color: #3159ff;
  border-color: #3159ff;
  z-index: 1;
}

.tab-item.active {
  color: #3159ff;
  border-color: #3159ff;
  background-color: #f0f7ff;
  z-index: 2;
}

.template-content {
  width: 500px;
  height: 380px;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }

  &:hover {
    &::-webkit-scrollbar {
      display: block;
      width: 3px;
      height: 3px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: #dddee0;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #c7c9cc;
    }
  }
}

.template-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 20px;
}

.template-item {
  position: relative;
  width: 100px;
  // height: 100px;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
}

.template-image {
  width: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.template-name {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 12px;
  text-align: center;
  line-height: 1.5;
  // 一行
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.template-selected-icon {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 20px;
  height: 20px;
  z-index: 10;
}
</style>
